<template>
  <custom-plane
    :title="`空调(${areaName})`"
    :iconImg="require('@/assets/compImg/icon/air-icon.png')"
  >
    <div class="air-num">
      <div class="air-item">
        <div class="item-name">正常数量</div>
        <div class="item-num color1">
          {{ totalNum[0] }}<span class="slash">/</span>
          <span class="all">
            {{ totalNum[0] }}
          </span>
        </div>
      </div>
      <div class="air-item">
        <div class="item-name">待机数量</div>
        <div class="item-num color1">
          {{ totalNum[1] }}
        </div>
      </div>
      <div class="air-item">
        <div class="item-name">故障数量</div>
        <div class="item-num color2">
          {{ totalNum[2] }}
        </div>
      </div>
    </div>
  </custom-plane>
</template>

<script>
export default {
  props: {
    totalCount: Array,
    areaName: String,
  },
  data() {
    return {
      buildMap: {
        总: "total",
        B3: "04",
        B1B2: "03",
        A2: "02",
        A1: "01",
      },
    };
  },
  computed: {
    totalNum() {
      let res = [];
      if (this.totalCount.length != 0 && this.buildMap[this.areaName]) {
        for (let item of this.totalCount) {
          if (item.buildNo == this.buildMap[this.areaName]) {
            res.push(item.normal, item.standby, item.fault);
            return res;
          }
        }
      }
      return ["-", "-", "-"];
    },
  },
};
</script>

<style lang="scss" scoped>
.air-num {
  width: 416px;
  height: 126px;
  display: flex;
  padding: 20px 34px;
  justify-content: space-between;
  .air-item {
    height: 92px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item-name {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      color: #fff;
      margin-bottom: 10px;
    }
    .item-num {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 55px;
      font-size: 48px;
      line-height: 55px;
      font-family: "dina";
      .slash {
        color: rgba(255, 255, 255, 0.5);
        margin: 0 8px;
      }
      .all {
        color: rgba(255, 255, 255, 0.5);
      }
      span {
        font-family: "dina";
      }
    }
  }
}
</style>
